import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NewSubscriptionStep4Page } from './new-subscription-step4';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  declarations: [
    NewSubscriptionStep4Page,
  ],
  imports: [
    IonicSelectableModule,
    BrMaskerModule,
    IonicPageModule.forChild(NewSubscriptionStep4Page),
  ],
  exports: [
    NewSubscriptionStep4Page
  ]
})
export class NewSubscriptionStep4PageModule { }



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step4/new-subscription-step4.module.ts